import { gsap } from 'gsap';

export function roundedButtonInit(el) {
  const content = el.querySelector('p');

  gsap.set(el, { scale: 0, transformOrigin: '50% 50%' });
  gsap.set(content, { opacity: 0, translateY: 20 });
}

export function roundedButtonEnter(el) {
  const content = el.querySelector('p');
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(el, {
      scale: 1,
      ease: 'bloom',
    }, 'start')
    .to(content, {
      opacity: 1,
      translateY: 0,
      duration: 1.5,
      ease: 'bloom',
    }, 'start+=0.1');

  return tl;
}

export function roundedButtonLeave(el) {
  el.removeAttribute('data-animated');
  const content = el.querySelector('p');
  const tl = gsap.timeline();

  tl.addLabel('start')
    .to(content, {
      opacity: 0,
      translateY: 20,
      duration: 0.7,
      ease: 'bloom',
    }, 'start')
    .to(el, {
      scale: 0,
      ease: 'bloom',
    }, 'start+=0.1');

  return tl;
}
